import { render, staticRenderFns } from "./questionCorrect.vue?vue&type=template&id=3cb21a42&scoped=true"
import script from "./questionCorrect.vue?vue&type=script&lang=js"
export * from "./questionCorrect.vue?vue&type=script&lang=js"
import style0 from "./questionCorrect.vue?vue&type=style&index=0&id=3cb21a42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb21a42",
  null
  
)

export default component.exports